import { render } from "./NoiseGenerator.vue?vue&type=template&id=02bb7bf3&ts=true&lang=html"
import script from "./NoiseGenerator.vue?vue&type=script&lang=ts"
export * from "./NoiseGenerator.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__